import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getStyles } from '../styles';
import { EntityListEnum } from '@beable/roster-backend-client-v1';

type Metrics = { rostered?: string | number, active?: string | number, provisioned?: string | number, available?: string | number };

interface MetricsProps {
  bgcolor: string;
  title: string;
  metrics: Metrics;
  isLoading: boolean;
  dataKey: EntityListEnum;
  onClick: (title: EntityListEnum) => void;
}

export default function MetricsContainer({ bgcolor, title, metrics, isLoading, dataKey, onClick }: MetricsProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  const metricLabels = { rostered: 'Rostered', active: 'Activated', provisioned: 'Provisioned', available: 'Available' }

  return (
    <Box
      onClick={() => onClick(dataKey)}
      sx={[{
        bgcolor: bgcolor
      }, styles.metricsContent]}>
      <>
      <Typography gutterBottom variant="h6">
        {title}
      </Typography>
      {isLoading ? 
        "Loading..." 
        :
        Object.keys(metricLabels).map((key) => {
          const useKey = key as keyof Metrics;
          return (metrics[useKey]) ? (
          <Typography gutterBottom variant="body2" key={useKey}>
            {`${metricLabels[useKey]}: ${metrics[useKey]}`}
          </Typography>
        ) : '' })
      }
      </>
    </Box>
  );
}